(function () {
  // Only run on devices that actually support hover
  if (!window.matchMedia || !window.matchMedia("(hover: hover)").matches) return;

  function normalizeTarget(e) {
    // e.target can be a Text node — normalize to an Element
    if (e.target && e.target.nodeType === 1) return e.target;
    return e.target && e.target.parentElement ? e.target.parentElement : null;
  }

  function findHoverImagesRoot(e) {
    // Prefer composedPath (handles custom elements / shadow DOM better)
    if (e.composedPath) {
      const path = e.composedPath();
      for (let i = 0; i < path.length; i++) {
        const el = path[i];
        if (el && el.tagName && el.tagName.toLowerCase() === "hover-images") {
          return el;
        }
      }
    }

    const target = normalizeTarget(e);
    return target ? target.closest("hover-images") : null;
  }

  function getActiveSlide(hoverEl) {
    return (
      hoverEl.querySelector(".is-selected") ||
      hoverEl.querySelector("[data-hover-slide]") ||
      hoverEl.querySelector("[data-hover-slide-touch]")
    );
  }

  function loadAndPlay(video) {
    if (!video) return;

    // Set properties explicitly (Safari + Chrome autoplay safe)
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.setAttribute("autoplay", "autoplay");

    if (!video.getAttribute("src")) {
      video.setAttribute("src", video.dataset.src);
      video.load();
    }

    const tryPlay = () => {
      const p = video.play();
      if (p && typeof p.catch === "function") {
        p.catch(() => {});
      }
    };

    if (video.readyState >= 3) {
      tryPlay();
    } else {
      video.addEventListener("canplay", tryPlay, { once: true });
      video.addEventListener("loadeddata", tryPlay, { once: true });
    }
  }

  function pauseAll(hoverEl) {
    hoverEl.querySelectorAll("video.media-video--deferred").forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });
  }

  // Hover enter
  document.addEventListener(
    "mouseenter",
    function (e) {
      const hover = findHoverImagesRoot(e);
      if (!hover) return;

      const active = getActiveSlide(hover);
      const video =
        active && active.querySelector("video.media-video--deferred[data-src]");
      loadAndPlay(video);
    },
    true
  );

  // Hover leave
  document.addEventListener(
    "mouseleave",
    function (e) {
      const hover = findHoverImagesRoot(e);
      if (!hover) return;

      pauseAll(hover);
    },
    true
  );

  // Watch Flickity slide changes (.is-selected)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === "attributes" && m.attributeName === "class") {
        const slide = m.target;
        if (slide.classList && slide.classList.contains("is-selected")) {
          const video = slide.querySelector(
            "video.media-video--deferred[data-src]"
          );
          loadAndPlay(video);
        }
      }
    }
  });

  function initObserver() {
    document
      .querySelectorAll(
        "hover-images [data-hover-slide], hover-images [data-hover-slide-touch]"
      )
      .forEach((slide) => {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver);
  } else {
    initObserver();
  }
})();